import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== "/contacto" ) {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        document.getElementById("contacto").scrollIntoView({
          behavior: "smooth",
        });
      }, 1500);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;

